var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgScribbleShineLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.83 26.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#00c68e;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;stroke-dasharray:50 3 100 3;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.75,24.78s5.86.75,7.31,1.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.79,4.78a48.06,48.06,0,0,0,5.67,5.58c1.46,1.19,6.38,6.14,6.38,6.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.6.75s.38,6.51.48,6.72"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScribbleShineLeft);
export default __webpack_public_path__ + "static/media/scribble-shine-left.fee1abc52ebd1fb4d57ef0db6291bf81.svg";
export { ForwardRef as ReactComponent };